const state = {
  loading: false,
  dialog: false,
  overlay: false,
  kodepromo: [],
  totalkodepromo: 0
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdata (state, s) {
    state.kodepromo = []
    state.kodepromo = s.data.content
    state.totalkodepromo = s.data.totalElements
    state.loading = false
    state.overlay = false
  }
}

export const FeedStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
